<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-button type="success" size="large" @click="downloadFile"
        ><img
          src="@/assets/images/icons/download.svg"
          alt=""
          style="margin-right: 5px"
        />
        Savollar listini yuklab olish
      </el-button>
      <el-input
        v-model="search"
        size="large"
        style="width: 250px; margin: 0 10px"
        placeholder="Izlash"
        clearable
        @clear="onSearch"
      >
        <template #append>
          <el-button style="display: flex" @click="onSearch"
            ><img src="@/assets/images/icons/search.svg" alt="search" />
          </el-button>
        </template>
      </el-input>
      <el-select
        size="large"
        placeholder="Viloyat boyicha"
        style="margin: 0 10px"
        v-model="regionId"
        @change="getQuestions"
        :loading="loading"
      >
        <el-option
          v-for="region in regions"
          :key="region.id"
          :value="region.id"
          :label="region.title"
        />
      </el-select>
      <el-select
        v-model="selectedType"
        size="large"
        clearable
        @change="onChangeFilter"
        style="margin: 0 10px"
        placeholder="Turi"
      >
        <el-option
          v-for="current_type in types"
          :value="current_type.value"
          :label="current_type.title"
          :key="current_type.id"
        ></el-option>
      </el-select>

      <el-select
        v-model="selectedStatus"
        size="large"
        clearable
        @change="onChangeFilter"
        placeholder="Status"
      >
        <el-option
          v-for="status in statuses"
          :value="status.value"
          :label="status.title"
          :key="status.id"
        ></el-option>
      </el-select>
    </div>
    <el-table
      :data="questions"
      class="table"
      border
      height="calc(100vh - 263px)"
    >
      <el-table-column type="expand">
        <template #default="scope">
          <div>
            <div class="desc-item">
              <span class="field-title">Murojaat matni:</span>

              <span v-html="scope.row.question"></span>
            </div>
            <div
              class="desc-item"
              v-if="
                scope.row.status === 'ANSWERED' ||
                scope.row.status === 'REJECTED'
              "
            >
              <AnswerItem :question="scope.row" />
            </div>
            <div class="desc-item" v-if="$store.state.role === 'admin'">
              <el-button
                v-if="scope.row.status == 'NEW'"
                size="default"
                type="danger"
                @click="
                  toggleChangeStatusModal(
                    scope.row.question_id,
                    scope.row.status
                  )
                "
              >
                Rad Etish
              </el-button>
              <el-button
                v-if="scope.row.status !== 'NEW'"
                size="default"
                type="primary"
                @click="
                  toggleChangeStatusModal(
                    scope.row.question_id,
                    scope.row.status,
                    scope.row.answer
                  )
                "
              >
                Javobni tahrirlash
              </el-button>
              <el-button
                v-if="scope.row.status == 'NEW'"
                size="default"
                type="primary"
                @click="toggleAnswerToQuestionModal(scope.row.question_id)"
              >
                Javob berish
              </el-button>
              <el-button
                size="default"
                type="primary"
                @click="
                  toggleChangeTypeModal(scope.row.type, scope.row.question_id)
                "
              >
                Turini ozgartirish
              </el-button>
              <el-button
                size="default"
                type="danger"
                @click="onDeleteQuestion(scope.row.question_id)"
              >
                Ochirib yuborish
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="public_id" label="ID">
        <template #default="scope">
          <div class="initiative-title" v-html="scope.row.public_id"></div>
        </template>
      </el-table-column>
      <el-table-column
        prop="author_name"
        label="Murojaat muallifi"
        min-width="220"
      >
        <template #default="scope">
          <el-button
            link
            type="primary"
            size="small"
            @click="
              toggleInitiativeModal(scope.row.author_id, scope.row.author_name)
            "
          >
            {{ scope.row.author_name }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="answer" label="Murojaat matni" min-width="200">
        <template #default="scope">
          <div class="initiative-title" v-html="scope.row.question"></div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Yaratilgan sana" width="180">
        <template #default="scope">
          {{ $moment(scope.row.created_date).format("LLL") }}
        </template>
      </el-table-column>
      <el-table-column prop="stage" label="Turi" width="150">
        <template #default="scope">
          <el-tag
            :type="
              types.find((currentType) => currentType.value == scope.row?.type)
                ?.type
            "
          >
            {{
              types.find((currentType) => currentType.value == scope.row.type)
                ?.title
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="stage" label="Status" width="170">
        <template #default="scope">
          <el-tag
            :type="
              statuses.find(
                (currentType) => currentType.value == scope.row.status
              ).type
            "
          >
            {{
              statuses.find(
                (currentType) => currentType.value == scope.row.status
              ).title
            }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span v-if="totalCount">Jami: {{ totalCount }}</span>
          <el-pagination
            class="pagination"
            background
            layout="sizes, prev, pager, next"
            :total="totalCount"
            v-model:page-size="limit"
            v-model:current-page="currentPage"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <!--delete question dialog-->

    <!--    answer to question dialog-->
    <el-dialog
      v-model="showAnswerToQuestionDialog"
      title="Murojaatga javob yo'llash"
      @close="closeAnswerToQuestionForm"
      style="max-width: 600px"
      align-center
    >
      <el-form
        ref="answerToQuestionForm"
        :model="answerToQuestionForm"
        :rules="answerToQuestionRule"
        label-position="top"
        style="width: 500px"
        status-icon
        hide-required-asterisk
      >
        <el-tabs
          v-model="answerFormat.selected"
          class="demo-tabs"
          @tab-click="handleSelectAnswerFormat"
        >
          <el-tab-pane label="Ruchnoy" name="withoutTemplate">
            <el-form-item label="Javob matni" prop="answer">
              <el-input
                v-model="answerToQuestionForm.answer"
                type="textarea"
                :rows="5"
                placeholder="Javob matnini kiriting."
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Shablon orqali" name="withTemplate">
            <el-form-item label="Mavjud Shablonlar" prop="answer">
              <el-select
                v-model="answerToQuestionForm.answer"
                size="large"
                clearable
                style="margin-right: 10px"
                placeholder="Mavjud Shablonlar"
              >
                <el-option
                  v-for="answer in answerTemplates"
                  :value="answer.context"
                  :label="answer.context"
                  :key="answer.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeAnswerToQuestionForm">Bekor qilish</el-button>
          <el-button type="primary" @click="completeAnswerToQuestion">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!--    edit type dialog-->
    <el-dialog
      v-model="showChangeTypeDialog"
      title="Turini ozgartirish"
      @close="closeTypeForm"
      style="max-width: 600px"
      align-center
    >
      <el-form
        ref="typeForm"
        :model="typeForm"
        :rules="typeFormRules"
        label-position="top"
        style="width: 500px"
        status-icon
        hide-required-asterisk
      >
        <el-form-item label="Javob matni" prop="type">
          <el-select
            v-model="typeForm.type"
            size="large"
            clearable
            style="margin-right: 10px"
            placeholder="Turi"
          >
            <el-option
              v-for="current_type in typeForm.types"
              :value="current_type.value"
              :label="current_type.title"
              :key="current_type.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeTypeForm">Bekor qilish</el-button>
          <el-button type="primary" @click="completeTypeChange">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!--    user initiatives show/close dialog-->
    <el-dialog v-model="showUserInitiatives" :show-close="false">
      <template #header="{ close, titleId, titleClass }">
        <div class="my-header">
          <h4 :id="titleId" :class="titleClass">{{ selectedUser }}</h4>
          <ElButton type="danger" @click="close"> Yopish </ElButton>
        </div>
      </template>
      <UserInitiatiatives
        :item="{ list: userInitiatiatives, loading: userInitiativesLoading }"
      />
    </el-dialog>

    <!--    status change dialog-->
    <el-dialog
      v-model="showStatusChangeDialog"
      title="Murojaatni statusini tahrirlash"
      @close="closeStatusChangeForm"
      style="max-width: 600px"
      align-center
    >
      <el-form
        ref="statusChangeForm"
        label-position="top"
        :model="statusChangeForm"
        style="width: 500px"
        :rules="statusRules"
        status-icon
        hide-required-asterisk
      >
        <el-tabs
          v-model="answerFormat.selected"
          class="demo-tabs"
          @tab-click="handleSelectAnswerFormat"
        >
          <el-tab-pane label="Ruchnoy" name="withoutTemplate">
            <el-form-item
              :label="
                statusChangeForm.currentStatus == 'NEW'
                  ? 'Rad etish sababi'
                  : 'Javob tahrirlash'
              "
              prop="answer"
            >
              <el-input
                v-model="statusChangeForm.answer"
                type="textarea"
                :rows="5"
                :placeholder="
                  statusChangeForm.currentStatus == 'NEW'
                    ? 'Rad etilish sababini kiriting. Masalan: Odob axloq qoidalariga amal qilmagani uchun savol rad etildi'
                    : 'Javob tahrirlash'
                "
              />
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="Shablon orqali" name="withTemplate">
            <el-form-item label="Mavjud Shablonlar" prop="answer">
              <el-select
                v-model="statusChangeForm.answer"
                size="large"
                clearable
                style="margin-right: 10px"
                placeholder="Mavjud Shablonlar"
              >
                <el-option
                  v-for="answer in answerTemplates"
                  :value="answer.context"
                  :label="answer.context"
                  :key="answer.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeStatusChangeForm">Bekor qilish</el-button>
          <el-button type="primary" @click="completeStatusChange()">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  ElButton,
  ElIcon,
  ElMessage,
  ElMessageBox,
  ElNotification,
} from "element-plus";
import AnswerItem from "@/views/questions/components/Answer.vue";
import UserInitiatiatives from "@/views/questions/components/UserInitiatives.vue";
export default {
  name: "QuestionList",
  components: { AnswerItem, ElIcon, ElButton, UserInitiatiatives },
  data() {
    return {
      showUserInitiatives: false,
      loading: false,
      selectedStatus: null,
      selectedType: null,
      answerTemplates: [],
      statuses: [
        { id: 1, title: "Barchasi", value: null, type: "primary" },
        { id: 2, title: "Yangi", value: "NEW", type: "primary" },
        { id: 3, title: "Javob berilgan", value: "ANSWERED", type: "success" },
        { id: 4, title: "Rad etilgan", value: "REJECTED", type: "danger" },
      ],
      types: [
        { id: 1, title: "Barchasi", value: -1, type: "primary" },
        {
          id: 5,
          title: "Majburiy ovoz tuplash yuzasidan",
          value: 3,
          type: "primary",
        },
        { id: 2, title: "Takliflar", value: 0, type: "primary" },
        { id: 3, title: "Shikoyat", value: 1, type: "danger" },
        { id: 4, title: "Tashakkurnomalar", value: 2, type: "success" },
        { id: 5, title: "Savol", value: 4, type: "success" },
      ],
      questions: [],
      totalCount: 0,
      selectedUser: null,
      userInitiativesLoading: false,
      userInitiatiatives: [],
      regions: [],
      regionId: null,
      limit: 20,
      currentPage: 1,
      search: null,
      showStatusChangeDialog: false,
      showAnswerToQuestionDialog: false,
      showChangeTypeDialog: false,
      statusChangeForm: {
        questionId: null,
        selectedStatus: "REJECTED",
        answer: null,
        currentStatus: null,
      },
      typeForm: {
        type: null,
        questionId: null,
        types: [
          {
            id: 5,
            title: "Majburiy ovoz tuplash yuzasidan",
            value: 3,
            type: "primary",
          },
          { id: 2, title: "Takliflar", value: 0, type: "primary" },
          { id: 3, title: "Shikoyat", value: 1, type: "danger" },
          { id: 4, title: "Tashakkurnomalar", value: 2, type: "success" },
          { id: 5, title: "Savol", value: 4, type: "success" },
        ],
      },
      answerToQuestionForm: {
        questionId: null,
        answer: null,
        status: "ANSWERED",
      },
      answerFormat: {
        selected: "withoutTemplate",
      },

      typeFormRules: {
        type: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
      },

      answerToQuestionRule: {
        answer: [
          { required: true, message: "Majburiy maydon", trigger: "change" },
        ],
      },
      statusRules: {
        answer: [
          { required: true, message: "Majburiy maydon", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    toggleInitiativeModal(id, user) {
      this.selectedUser = user;
      this.showUserInitiatives = true;
      this.userInitiativesLoading = true;
      this.$http
        .get(`/api/v1/moderators/user/${id}/initiatives`)
        .then(({ data }) => {
          this.userInitiatiatives = data.initiatives;
        })
        .catch(() => {
          ElNotification({
            type: "error",
            title: "Xatolik",
            message: "Iltimos, qayta urinib ko'ring",
          });
        })
        .finally(() => {
          this.userInitiativesLoading = false;
        });
    },
    handleSelectAnswerFormat(tab) {
      console.log(tab);
    },
    getRegions() {
      this.loading = true;
      this.$http
        .get("/api/v1/regions")
        .then(({ data }) => {
          this.regions = data.regions;
          this.getQuestions();
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    getAnswerTemplates() {
      this.$http
        .get("/api/v1/answer-template")
        .then(({ data }) => {
          this.answerTemplates = data.result;
        })
        .catch(() => {});
    },
    downloadFile() {
      this.loading = true;
      this.$http
        .get(`api/v1/questions/excel`, {
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const header = res.headers.get("Content-Disposition");
          const parts = header.split(";");
          let fileName = parts[1].split("=")[1];
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onDeleteQuestion(id) {
      ElMessageBox.confirm("Ushu savolni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .request({
              url: `/api/v1/questions/${id}`,
              method: "delete",
            })
            .then(() => {
              ElMessage({
                type: "success",
                message: "Ushbu savol o'chirildi",
              });
              this.getQuestions();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    getQuestions() {
      this.loading = true;

      this.$http
        .get(`api/v1/questions`, {
          params: {
            region_id: this.regionId,
            limit: this.limit,
            offset: this.limit * (this.currentPage - 1),
            type: this.selectedType,
            status: this.selectedStatus,
            search: this.search,
          },
        })
        .then(({ data }) => {
          this.questions = data.questions;
          this.totalCount = data.count;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onSearch() {
      this.currentPage = 1;
      this.$router.replace({ query: { ...this.$route.query } });
      this.getQuestions();
    },

    onChangeFilter() {
      this.currentPage = 1;
      this.$router.replace({
        query: {
          ...this.$route.query,
          status: this.selectedStatus,
          type: this.selectedType,
        },
      });
      this.getQuestions();
    },
    closeStatusChangeForm() {
      this.showStatusChangeDialog = false;
      this.statusChangeForm = {
        questionId: null,
        selectedStatus: "REJECTED",
        answer: null,
        statusChangeForm: null,
      };
    },
    closeAnswerToQuestionForm() {
      this.showAnswerToQuestionDialog = false;
      this.answerToQuestionForm = {
        questionId: null,
        answer: null,
        status: "ANSWERED",
      };
    },

    closeTypeForm() {
      this.showChangeTypeDialog = false;
      this.typeForm = {
        ...this.typeForm,
        questionId: null,
        type: null,
      };
    },
    completeTypeChange() {
      this.$refs.typeForm.validate((valid) => {
        if (valid) {
          const data = {
            type: this.typeForm.type,
          };
          this.loading = true;
          this.$http
            .put(`api/v1/questions/${this.typeForm.questionId}`, data)
            .then(() => {
              ElNotification.success({
                message: "Muvofaqiyatli turi ozgartirildi",
              });
              this.closeTypeForm();
              this.getQuestions();
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    completeStatusChange(id) {
      this.$refs.statusChangeForm.validate((valid) => {
        if (valid) {
          if (this.statusChangeForm.currentStatus == "NEW") {
            const data = {
              status: this.statusChangeForm.selectedStatus,
              context: this.statusChangeForm.answer,
            };
            this.loading = true;
            this.$http
              .post(
                `api/v1/questions/${this.statusChangeForm.questionId}/answer`,
                data
              )
              .then(() => {
                ElNotification.success({
                  message: "Muvofaqiyatli rad etildi",
                });
                this.closeStatusChangeForm();
                this.getQuestions();
              })
              .catch((error) => {
                console.log(error);
                ElNotification.error({
                  message:
                    error.response.data.message ||
                    "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          } else {
            const data = {
              context: this.statusChangeForm.answer,
            };
            this.loading = true;
            this.$http
              .put(
                `api/v1/questions/${this.statusChangeForm.questionId}/answer`,
                data
              )
              .then(() => {
                ElNotification.success({
                  message: "Muvofaqiyatli javob tahrirlandi!",
                });
                this.closeStatusChangeForm();
                this.getQuestions();
              })
              .catch((error) => {
                console.log(error);
                ElNotification.error({
                  message:
                    error.response.data.message ||
                    "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
          }
        }
      });
    },
    completeAnswerToQuestion() {
      this.$refs.answerToQuestionForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const data = {
            context: this.answerToQuestionForm.answer,
            status: this.answerToQuestionForm.status,
          };
          this.$http
            .post(
              `api/v1/questions/${this.answerToQuestionForm.questionId}/answer`,
              data
            )
            .then(() => {
              ElNotification.success({
                message: "Murojatga javob yo'llandi.",
              });
              this.closeAnswerToQuestionForm();
              this.getQuestions();
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    toggleAnswerToQuestionModal(id) {
      this.showAnswerToQuestionDialog = true;
      this.answerToQuestionForm.questionId = id;
    },

    closeDeleteModal() {
      this.showDeleteModal = false;
      this.currentQuestionId = null;
    },
    toggleChangeTypeModal(type, questionId) {
      this.showChangeTypeDialog = true;
      console.log(type, "type");
      this.typeForm.questionId = questionId;
      this.typeForm.type = type;
    },
    toggleChangeStatusModal(id, status, answer = null) {
      this.showStatusChangeDialog = true;
      this.statusChangeForm.questionId = id;
      this.statusChangeForm.currentStatus = status;
      if (status !== "NEW") {
        this.statusChangeForm.answer = answer;
      }
    },
    generateSrcList(imgList) {
      return imgList.map(
        (image) => `http://cdn.obod-qishloq.hapirin.uz/images/${image}`
      );
    },

    handleSizeChange() {
      this.$router.replace({
        query: { ...this.$route.query, size: this.limit, page: 1 },
      });
      this.currentPage = 1;
      this.getQuestions();
    },
    handleCurrentChange() {
      this.$router.replace({
        query: { ...this.$route.query, page: this.currentPage },
      });
      this.getQuestions();
    },
  },

  mounted() {
    this.getRegions();
    this.getAnswerTemplates();
    if (this.$route.query.status) {
      this.selectedStatus = this.$route.query.status;
    }
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.type) {
      this.selectedType = this.$route.query.type;
    }
    this.$nextTick(() => {
      this.getQuestions();
    });
  },
};
</script>

<style scoped>
.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}

.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.initiative-title,
:deep(.el-dialog__header) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.desc-item {
  margin: 10px;
}

.field-title {
  color: #0f152d;
  font-weight: bold;
  margin-right: 5px;
}

:deep(.el-table .el-table__cell) {
  z-index: unset !important;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 3px;
  height: 40px;
}

.pagination-wrapper > span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}

.my-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
